import type { ShopifyImage } from '$types/shopify';

export const getGalleryPhotos = (
  images: ShopifyImage[],
  variant: 'default' | 'highlight' | 'all' = 'default'
) => {
  if (variant === 'default') {
    if (images.length >= 4) {
      return [images[0], images[1], images[3]];
    } else {
      return [...images.slice(0, 3)];
    }
  } else if (variant === 'highlight') {
    if (images.length >= 4) {
      return [images[1], images[0], images[3]];
    } else if (images.length >= 2 && images.length < 4) {
      return [images[1], images[0], ...images.slice(2)];
    } else {
      return [...images.slice(0, 3)];
    }
  } else {
    return images;
  }
};
